var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIconFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 82,
    viewBox: "0 0 124 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 71.4719C124 65.6644 119.29 60.9338 113.5 60.9338C112.2 60.9338 110.92 61.1754 109.69 61.6585L109.39 61.7793L109.22 61.5075C106.28 56.8071 101.24 54.009 95.72 54.009C89.86 54.009 84.48 57.2298 81.7 62.4134L81.56 62.665L81.27 62.6046C80.65 62.4737 80.02 62.4134 79.4 62.4134C74.42 62.4134 70.37 66.4796 70.37 71.4719C70.37 72.0154 70.43 74.4109 70.52 74.9242H123.87C123.95 74.4109 124 72.0054 124 71.4719Z",
    fill: "#B0C0CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.13 74.9243H20.11C18.62 74.9243 17.41 73.7064 17.41 72.2067V2.71756C17.41 1.21787 18.62 0 20.11 0H101.13C102.62 0 103.83 1.21787 103.83 2.71756V72.2168C103.83 73.7165 102.62 74.9243 101.13 74.9243Z",
    fill: "#F3F4F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.85 65.8858H25.82C25.08 65.8858 24.47 65.2819 24.47 64.5271V13.8495C24.47 13.1047 25.08 12.4907 25.82 12.4907H95.85C96.6 12.4907 97.2 13.1047 97.2 13.8495V64.5271C97.2 65.2819 96.59 65.8858 95.85 65.8858Z",
    fill: "#C1C1FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.55 68.2511C48.65 68.2511 46.85 68.7241 45.28 69.5495C42.22 65.3926 37.26 62.675 31.65 62.675C29.31 62.675 27.08 63.1481 25.05 64.0036C29.24 68.6738 34.4401 72.418 40.3101 74.9242H60.82C59.1101 70.9989 55.16 68.2511 50.55 68.2511Z",
    fill: "#B0C0CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.7 0H19.48C18.46 0 17.61 0.714619 17.4 1.68086V6.97508H103.83V2.14386C103.83 0.95618 102.88 0 101.7 0Z",
    fill: "#8282F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.15 81.9999C58.37 81.1343 58.5 80.2385 58.5 79.3025C58.5 73.203 53.49 68.2611 47.3 68.2611C45.39 68.2611 43.6 68.7342 42.03 69.5595C38.97 65.4026 34.01 62.6851 28.4 62.6851C21.84 62.6851 16.17 66.389 13.39 71.7839C12.07 71.0089 10.53 70.5559 8.87 70.5559C3.97 70.5559 0 74.4712 0 79.3025C0 80.2486 0.16 81.1544 0.44 81.9999H58.15Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3399 58.7698C84.3399 60.1688 83.2199 61.2961 81.8299 61.2961C80.4399 61.2961 79.3199 60.1588 79.3199 58.7698C79.3199 57.3708 80.4399 56.2435 81.8299 56.2435C83.2099 56.2334 84.3399 57.3708 84.3399 58.7698Z",
    fill: "#C1C1FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.26 3.39202C23.26 4.04625 22.73 4.5797 22.08 4.5797C21.43 4.5797 20.9 4.04625 20.9 3.39202C20.9 2.73779 21.43 2.20435 22.08 2.20435C22.73 2.21441 23.26 2.73779 23.26 3.39202Z",
    fill: "#C1C1FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.47 3.39197C27.47 4.0462 26.94 4.57964 26.29 4.57964C25.64 4.57964 25.11 4.0462 25.11 3.39197C25.11 2.73774 25.65 2.21436 26.3 2.21436C26.95 2.21436 27.47 2.73774 27.47 3.39197Z",
    fill: "#C1C1FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.69 3.39202C31.69 4.04625 31.16 4.5797 30.51 4.5797C29.86 4.5797 29.33 4.04625 29.33 3.39202C29.33 2.73779 29.86 2.20435 30.51 2.20435C31.16 2.21441 31.69 2.73779 31.69 3.39202Z",
    fill: "#C1C1FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.02 65.8858L70.83 62.8261L70.49 62.353C70.16 61.89 70.26 61.2458 70.72 60.9036L71.89 60.0582L68.78 55.7101C60.76 60.3299 50.41 58.1961 44.89 50.4863C38.99 42.243 40.84 30.7387 49.04 24.8003C57.23 18.8619 68.66 20.7239 74.56 28.9773C80.08 36.6871 78.81 47.2454 71.92 53.4454L75.03 57.7935L76.2 56.9481C76.66 56.6159 77.3 56.7166 77.64 57.1796L77.98 57.6526L83.88 65.8959L73.02 65.8858Z",
    fill: "#B0B0F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 65.8857L86.67 69.791C88.09 71.7738 87.64 74.5518 85.67 75.981C83.7 77.4102 80.94 76.9573 79.52 74.9745L73.02 65.8857H83.88Z",
    fill: "#E8E9EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9232 50.1449L67.7831 52.4216L72.7455 59.3552L75.8856 57.0785L70.9232 50.1449Z",
    fill: "#A0A2F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7299 56.2435C69.8312 56.2435 78.0199 48.0015 78.0199 37.8345C78.0199 27.6675 69.8312 19.4255 59.7299 19.4255C49.6287 19.4255 41.4399 27.6675 41.4399 37.8345C41.4399 48.0015 49.6287 56.2435 59.7299 56.2435Z",
    fill: "#8184F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.73 53.5461C68.3512 53.5461 75.34 46.5118 75.34 37.8346C75.34 29.1573 68.3512 22.123 59.73 22.123C51.1088 22.123 44.12 29.1573 44.12 37.8346C44.12 46.5118 51.1088 53.5461 59.73 53.5461Z",
    fill: "#CDE1F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.85 50.587C75.85 45.5142 77.43 35.6907 72.39 28.6552C67.35 21.6198 57.59 20.0194 50.6 25.0922L68.85 50.587Z",
    fill: "#D6E7F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.64 55.2773L86.67 67.8989C88.09 69.8817 87.64 72.6597 85.67 74.0889C83.7 75.5182 80.94 75.0652 79.52 73.0824L70.49 60.4608L77.64 55.2773Z",
    fill: "#A0A2F4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.49 60.4608C70.16 59.9978 70.26 59.3536 70.72 59.0114L76.2 55.0357C76.66 54.7035 77.3 54.8042 77.64 55.2672L77.98 55.7402L70.83 60.9237L70.49 60.4608Z",
    fill: "#8184F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconFound);
export default __webpack_public_path__ + "static/media/search_icon_found.d60931d14b52d7467a99c1b48a536d2f.svg";
export { ForwardRef as ReactComponent };